/**
 * @module engine3d/models/cable
 * @summary Cable-extrusion line equipment — pay-offs, take-ups, caterpillars,
 *   capstans, accumulators, gauges, testers and the rest of a CV / insulation
 *   line, offered in the 3D view's Model picker.
 * @description
 *   These machines have no 2D symbol of their own yet, so they are registered
 *   through `EXTRA_MODELS` (kit decision D5): `models/index.ts` merges this
 *   table into the registry, labels the picker entries from `label`, and takes
 *   the Z depth rule from `depth`. A shape reaches one of these models ONLY by
 *   being pinned to it (`Shape.model3`) — nothing is inferred from a type or a
 *   label, so a renamed symbol never changes its 3D form.
 *
 *   Build every model from `./kit` (see .claude/premium/kit-api.md for the
 *   helper list and costs): `cableReel`, `beltTrack`, `sheave`, `roller`,
 *   `driveTrain`, `cabinet`, `hmiPanel`, `baseFrame`, `legStand` …
 *
 *   // INVARIANT: every builder here is a pure function of its Dims (plus the
 *   //   kit detail level) — the model cache shares one build across every
 *   //   instance and every frame.
 *   // INVARIANT: keys must not collide with a built-in model key; a colliding
 *   //   key is ignored by the registry rather than shadowing the built-in.
 */
import type { ExtraModels } from './kit';

/** Cable-line models for the 3D Model picker. Filled by the CABLE unit. */
export const EXTRA_MODELS: ExtraModels = {};
